import { IBackboneElement } from '../BackboneElement';
import { IDomainResource } from '../Resource';
import { ICodeableConcept } from '../CodeableConcept';
import { IReference } from '../Reference';
import { IIdentifier } from '../Identifier';
import { dateTime } from '../Primitives';
import { IAge } from '../Quantity';
import { IPeriod } from '../Period';
import { IRange } from '../Range';
import { IAnnotation } from '../Annotation';

export type ConditionType = 'Condition';

export const isCondition = (
  resource: object | null | undefined,
): resource is ICondition =>
  !!resource && (resource as ICondition).resourceType === 'Condition';

export interface IConditionEvidenceComponent extends IBackboneElement {
  code?: ICodeableConcept[];
  detail?: IReference[];
}

export interface IConditionStageComponent extends IBackboneElement {
  summary?: ICodeableConcept;
  assessment?: IReference[];
}

export type ConditionClinicalStatus =
  | 'active'
  | 'recurrence'
  | 'inactive'
  | 'remission'
  | 'resolved';

export type ConditionVerificationStatus =
  | 'provisional'
  | 'differential'
  | 'confirmed'
  | 'refuted'
  | 'entered-in-error'
  | 'unknown';

export interface ICondition extends IDomainResource<ConditionType> {
  identifier?: IIdentifier[];
  clinicalStatus?: ConditionClinicalStatus;
  verificationStatus?: ConditionVerificationStatus;
  category?: ICodeableConcept[];
  severity?: ICodeableConcept;
  code?: ICodeableConcept;
  bodySite?: ICodeableConcept[];
  subject: IReference;
  context?: IReference;
  onsetDateTime?: dateTime;
  onsetAge?: IAge;
  onsetPeriod?: IPeriod;
  onsetRange?: Range;
  onsetString?: string;
  abatementDateTime?: dateTime;
  abatementAge?: IAge;
  abatementBoolean?: boolean;
  abatementPeriod?: IPeriod;
  abatementRange?: IRange;
  abatementString?: string;
  assertedDate?: dateTime;
  asserter?: IReference;
  stage?: IConditionStageComponent[];
  evidence?: IConditionEvidenceComponent[];
  note?: IAnnotation[];
}
